import { render, staticRenderFns } from "./BranchRegionReportView.vue?vue&type=template&id=5767168e&scoped=true"
import script from "./BranchRegionReportView.vue?vue&type=script&lang=js"
export * from "./BranchRegionReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767168e",
  null
  
)

export default component.exports